import React, { useState } from 'react'
import { useResponsiveValue } from '@machobear/design-system'
import {
  AnimatePresence,
  easeInOut,
  motion,
  useMotionValueEvent,
  useScroll
} from 'framer-motion'

import { Listing } from '@/types'
import useRole from '@/hooks/use-role'
import ListingMessageHeader from '@/components/listing-message-header'

import { IMPORTED_LISTING_PLATFORM } from '../page'

type Props = {
  listings: Listing
  setShowTopNav: (value: boolean) => void
}

const StatusBanner = ({ listings, setShowTopNav }: Props) => {
  const role = useRole()
  const [hideMessageBar, setHideMessageBar] = useState(false)

  const listingState =
    listings.is_hidden === '1' ? 'hidden' : listings.state_machine
  const showMessageHeader = listingState !== 'published' && role === 'landlord'
  const isImported = listings?.tags?.some((tag: string) =>
    IMPORTED_LISTING_PLATFORM.includes(tag)
  )

  const { scrollYProgress } = useScroll()

  useMotionValueEvent(scrollYProgress, 'change', latest => {
    const prev = scrollYProgress?.getPrevious()
    if (latest > prev) {
      setShowTopNav(false)
    } else {
      setShowTopNav(true)
    }

    if (latest > 10) {
      setHideMessageBar(true)
    } else {
      setHideMessageBar(false)
    }
  })

  return (
    <>
      {showMessageHeader && !hideMessageBar && (
        <AnimatePresence>
          <motion.div
            initial={{ display: 'flex' }}
            animate={
              hideMessageBar
                ? { display: 'none', opacity: 0 }
                : { display: 'flex', opacity: 1 }
            }
            transition={{
              ease: easeInOut,
              type: 'spring',
              damping: 18
            }}
          >
            <ListingMessageHeader
              type={listingState}
              listingId={listings.id}
              externalInfo={listings.external_info}
              isImported={isImported}
            />
          </motion.div>
        </AnimatePresence>
      )}
    </>
  )
}

export default StatusBanner
